// Exports
export default {
	"pluginsSidebar": "pluginsSidebar_V-Cn2",
	"close": "close_nz4qW",
	"head": "head_MjRSx",
	"title": "title_-gcwu",
	"content": "content_aw7bX",
	"placeholder": "placeholder_QjbwV",
	"plugin": "plugin_Nk7kX",
	"pluginTitle": "pluginTitle_IvxGh",
	"pluginIframe": "pluginIframe_Czh2u",
	"pluginState": "pluginState_wdpaG"
};
